import cliui from 'cliui';
import { map, join } from 'lodash';

import { initializeCommand } from '../index';
import { getCurrentServices } from '../services';

export const command = 'list';
export const describe = `List the active services for this project.`;

export const builder = () => {
  initializeCommand();
};

export const handler = async(): Promise<void> => {
  const ui = cliui();
  const services = await getCurrentServices();
  const list = map(services, (service, serviceIndex) => {
    return `Service #${serviceIndex + 1}: ${service.name}\n`;
  });

  ui.div(join(list, ''));

  console.log(ui.toString());
};